import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'core/controls';

const ConfigAssistantListOption = props => {
  const { label, checked, icon, onChange } = props;
  return (
    <div className="config-assistant-engine">
      <Checkbox checked={checked} onChange={onChange}>
        {icon}
        <span dangerouslySetInnerHTML={{ __html: label }} />
      </Checkbox>
    </div>
  );
};

ConfigAssistantListOption.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  icon: PropTypes.node,
  onChange: PropTypes.func.isRequired
};

export default ConfigAssistantListOption;
